import { render, staticRenderFns } from "./CmgAddFavoriteOrderModal.vue?vue&type=template&id=1ea8afb4&scoped=true&lang=pug&"
import script from "./cmg-add-favorite-order-modal.ts?vue&type=script&lang=ts&"
export * from "./cmg-add-favorite-order-modal.ts?vue&type=script&lang=ts&"
import style0 from "./CmgAddFavoriteOrderModal.vue?vue&type=style&index=0&id=1ea8afb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea8afb4",
  null
  
)

export default component.exports